import React from 'react';
import { Meteor } from 'meteor/meteor';
import { Route, Link } from 'react-router';
import moment from 'moment';
import ReactDOM from 'react-dom';

import {
  Well,
  Table,
  Button,
  BPanel,
  Col,
  FormControl,
  FormGroup
} from '@sketchpixy/rubix';
var DatePicker = require("react-bootstrap-date-picker");

import {Line} from 'react-chartjs-2';

import { StatistiquesHelpers } from '../../helpers/statistiquesHelpers';
import { Tableau } from './Tableau.component';

import { Reactive } from '../common/Reactive.mixin.js';
import { Tracker } from 'meteor/tracker';

@Reactive({
	subscriptions: ["flights", "reservations-all"]
})
export default class StatistiquesPage extends React.Component {
  constructor(props) {
        super(props);
        this.state = {};

        //set start and ending date :
        this.state.startDate = moment().startOf('year').format();
        this.state.endDate = moment().format();
  }

  launchStatistiques() {
        let type = ReactDOM.findDOMNode(this.refs.statistiques_type).value.trim();
        let affichage = ReactDOM.findDOMNode(this.refs.statistiques_affichage).value.trim();

        let that = this;
        StatistiquesHelpers.launchStatistiques(type, this.state.startDate, this.state.endDate, affichage).then(function(data) {
	        that.setState({
	            launched: true,
	            data: data
	        });
        });

  }


  render() {
    return (
      <div>
        <BPanel header="Filtrer les statistiques :">
            <FormGroup>
                <Col sm={3}>
                    Statitiques :
                </Col>
                <Col sm={9}>
                   <FormControl componentClass="select" type="select" ref="statistiques_type">
                        <option value="reservations">Réservations</option>
                        <option value="vols">Vols</option>
                        <option value="pilotes-vols">Pilotes (vols)</option>
                        <option value="pilotes-heures">Pilotes (heures)</option>
                        <option value="montgolfieres-vols">Ballons (vols)</option>
                        <option value="montgolfieres-heures">Ballons (heures)</option>
                        <option value="vols/nonvols">Volées/Non Volées</option>
                    </FormControl>
                </Col>
            </FormGroup><hr/>
            <FormGroup>
                <Col sm={3}>
                    Affichage :
                </Col>
                <Col sm={9}>
                   <FormControl componentClass="select" type="select" ref="statistiques_affichage">
                        <option value="months">Par mois</option>
                        <option value="years">Par année</option>
                    </FormControl>
                </Col>
            </FormGroup><hr/><br/>
            <FormGroup>
                <Col sm={3}>
                    Dates :
                </Col>
                <Col sm={9}>
                    <Col sm={2}>
                        Du
                    </Col>
                    <Col sm={4}>
                        <DatePicker
                        dayLabels={['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam']}
                        monthLabels={['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Aout', 'Septembre', 'Octobre', 'Novembre', 'Decembre']}
                        id="start_date" value={this.state.startDate} onChange={(value) => this.setState({ startDate: value })}/>
                    </Col>
                    <Col sm={2}>
                        Au
                    </Col>
                    <Col sm={4}>
                        <DatePicker
                        dayLabels={['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam']}
                        monthLabels={['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Aout', 'Septembre', 'Octobre', 'Novembre', 'Decembre']}
                        id="end_date" value={this.state.endDate} onChange={(value) => this.setState({ endDate: value })} />
                    </Col>
                </Col>
            </FormGroup><br/><br/>
            <center><Button onClick={::this.launchStatistiques}>Filtrer</Button></center>
        </BPanel>
        <BPanel header="Données :">
        {this.state.launched &&
        	<Tableau data={this.state.data} />
        }
        {!this.state.launched &&
            <p>-</p>
        }
        </BPanel>
        <BPanel header="Graphique :">
        {this.state.launched &&
            <Line data={this.state.data} />
        }
        {!this.state.launched &&
            <p>Bienvenue sur votre interface de statisques, merci de séléctionner les statistiques à afficher.</p>
        }
        </BPanel>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/universal/components/statistiques/Statistiques.page.js
 **/